import { Hostname } from 'constants/hostnames';
import { Gender } from 'constants/user';
import { Screen } from 'constants/tracking/screens';
export const SMALLEST_AD_HEIGHT = 50;
export const GOOGLETAG_WAIT_CYCLES_LIMIT = 10;
export const GOOGLETAG_WAIT_TIME = 250;
export const GOOGLETAG_GENDER_VALUE_KEY = 'bs_a';
export const STICKY_AD_SPACING = 20;
export const REFRESH_AD_TIME = 15;
export const USER_INACTIVE_TIME = 5;
export const DEBOUNCE_TIME = 2000;
export const ADS_BIDDER_TIMEOUT = 2000;
export const AD_VISIBILITY_RATIO = 0.5;
export const IS_AD_BLOCKER_USED_SESSION_KEY = 'isAdBlockerUsed';
export const SHOULD_SHOW_ROKT_SESSION_KEY = 'shouldShowRokt';
export const ROKT_DFP_CODE = 'de_web_successful_purchase_rokt';
export const AD_BLOCKER_VISITOR_KEY = 'adBlockerVisitor';
export const AD_REQUEST_CHECK_URL = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';
export const APSTAG_PUB_ID = 3863;
export const SMART_ADSERVER_NETWORK_ID = 3230;
export const ACTIVITY_EVENTS = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart'];
export let Bidder;

(function (Bidder) {
  Bidder["Amazon"] = "a9";
  Bidder["Prebid"] = "prebid";
})(Bidder || (Bidder = {}));

export let BidderState;

(function (BidderState) {
  BidderState["Idle"] = "idle";
  BidderState["Fetched"] = "fetched";
  BidderState["TimedOut"] = "timedout";
  BidderState["NoBids"] = "nobids";
  BidderState["BadSizes"] = "badsizes";
})(BidderState || (BidderState = {}));

export let GoogleEventName;

(function (GoogleEventName) {
  GoogleEventName["SlotOnload"] = "slotOnload";
  GoogleEventName["SlotRequested"] = "slotRequested";
  GoogleEventName["SlotRenderEnded"] = "slotRenderEnded";
  GoogleEventName["ImpressionViewable"] = "impressionViewable";
})(GoogleEventName || (GoogleEventName = {}));

export let SmartAdServerEventName;

(function (SmartAdServerEventName) {
  SmartAdServerEventName["Call"] = "call";
  SmartAdServerEventName["NoAd"] = "noad";
  SmartAdServerEventName["Clean"] = "clean";
})(SmartAdServerEventName || (SmartAdServerEventName = {}));

export let AdKind;

(function (AdKind) {
  AdKind["Rtb"] = "rtb";
  AdKind["Direct"] = "direct";
})(AdKind || (AdKind = {}));

export let AdPlatform;

(function (AdPlatform) {
  AdPlatform["Mobile"] = "mobile";
  AdPlatform["Web"] = "web";
})(AdPlatform || (AdPlatform = {}));

export let AdShape;

(function (AdShape) {
  AdShape["Leaderboard"] = "leaderboard";
  AdShape["Rectangle"] = "rectangle";
  AdShape["Skyscraper"] = "skyscraper";
  AdShape["Inbetween"] = "inbetween";
})(AdShape || (AdShape = {}));

export let AdPage;

(function (AdPage) {
  AdPage["Feed"] = "feed";
  AdPage["Catalog"] = "catalog";
  AdPage["Forum"] = "forum";
  AdPage["ForumTopic"] = "forum_topic";
  AdPage["ForumPosts"] = "forum_posts";
  AdPage["Messages"] = "messages";
  AdPage["NewMessage"] = "new_message";
  AdPage["ReplyMessage"] = "reply_message";
  AdPage["Item"] = "item";
  AdPage["FavoriteItems"] = "favorite_items";
  AdPage["Notifications"] = "notifications";
  AdPage["Unknown"] = "unknown";
})(AdPage || (AdPage = {}));

export let AdGender;

(function (AdGender) {
  AdGender["Female"] = "1";
  AdGender["Male"] = "2";
  AdGender["Other"] = "3";
})(AdGender || (AdGender = {}));

export let PrebidPriceGranularityType;

(function (PrebidPriceGranularityType) {
  PrebidPriceGranularityType["Low"] = "low";
  PrebidPriceGranularityType["Medium"] = "medium";
  PrebidPriceGranularityType["High"] = "high";
  PrebidPriceGranularityType["Auto"] = "auto";
  PrebidPriceGranularityType["Dense"] = "dense";
})(PrebidPriceGranularityType || (PrebidPriceGranularityType = {}));

export let PrebidUserSyncFilterSettingType;

(function (PrebidUserSyncFilterSettingType) {
  PrebidUserSyncFilterSettingType["Image"] = "image";
  PrebidUserSyncFilterSettingType["Iframe"] = "iframe";
})(PrebidUserSyncFilterSettingType || (PrebidUserSyncFilterSettingType = {}));

export let PrebidConsentManagementCmpApiType; // TODO: When screen names will have enum of
// their own - change keys to that enum values

(function (PrebidConsentManagementCmpApiType) {
  PrebidConsentManagementCmpApiType["IAB"] = "iab";
  PrebidConsentManagementCmpApiType["Static"] = "static";
})(PrebidConsentManagementCmpApiType || (PrebidConsentManagementCmpApiType = {}));

export const MapScreenToAdPage = {
  [Screen.Catalog]: AdPage.Catalog,
  [Screen.FavoriteItemList]: AdPage.FavoriteItems,
  [Screen.NewsFeed]: AdPage.Feed,
  [Screen.Forum]: AdPage.Forum,
  [Screen.ForumTopic]: AdPage.ForumTopic,
  [Screen.ForumPosts]: AdPage.ForumPosts,
  [Screen.Item]: AdPage.Item,
  [Screen.MessageList]: AdPage.Messages,
  [Screen.MessageNew]: AdPage.Messages,
  [Screen.MessageReply]: AdPage.Messages,
  [Screen.NotificationList]: AdPage.Notifications
};
export const MapSasFormatsToAdShape = {
  [AdShape.Leaderboard]: 103490,
  [AdShape.Rectangle]: 103491,
  [AdShape.Skyscraper]: 103492,
  [AdShape.Inbetween]: 103493
};
export const MapUserGenderToAdGender = {
  [Gender.Male]: AdGender.Male,
  [Gender.Female]: AdGender.Female,
  [Gender.Other]: AdGender.Other
};
export const MapScreenToSasPageId = {
  [Screen.Catalog]: '1408495',
  [Screen.FavoriteItemList]: '1408496',
  [Screen.NewsFeed]: '1408496',
  [Screen.Forum]: '1408498',
  [Screen.ForumTopic]: '1408499',
  [Screen.ForumPosts]: '1408500',
  [Screen.Item]: '1408501',
  [Screen.MessageList]: '1408502',
  [Screen.MessageNew]: '1408503',
  [Screen.MessageReply]: '1411124',
  [Screen.NotificationList]: '1408504'
};
export const MapHostnameToSasSiteId = {
  [Hostname.At]: '405415',
  [Hostname.Be]: '405630',
  [Hostname.Cz]: '278341',
  [Hostname.De]: '405593',
  [Hostname.OldDe]: '278323',
  [Hostname.OldDeBabies]: '278339',
  [Hostname.Es]: '405595',
  [Hostname.Fr]: '269604',
  [Hostname.It]: '405600',
  [Hostname.Lt]: '405599',
  [Hostname.Lu]: '405597',
  [Hostname.Nl]: '405596',
  [Hostname.Pl]: '278340',
  [Hostname.FrSandbox]: '285225'
};
export const MapHostnameToPubstackKey = {
  [Hostname.At]: '2002dd12-cfdb-4c86-acac-9cdf9486fcaf',
  [Hostname.Be]: 'ffb4f10f-8663-4550-a525-581be2c04b19',
  [Hostname.Cz]: 'f7d00be3-675b-40d6-b04c-ca6a6116c111',
  [Hostname.De]: 'd9b97cad-0390-4322-bbd7-b7bb6bcba9a9',
  [Hostname.OldDe]: 'f9aea0b3-61d6-4409-ae0c-9bf1f5d413b0',
  [Hostname.OldDeBabies]: '23d6f372-1367-4b88-88fe-28077a20088d',
  [Hostname.Es]: 'fa8cbf13-e46c-4af7-b37e-126c04513563',
  [Hostname.Fr]: '8599f048-3b81-470f-8617-c842452d2caf',
  [Hostname.It]: '6990de06-43b4-4b6e-aa67-5169f9feef26',
  [Hostname.Lu]: '20292402-2e23-49f5-bee3-ac87ee790010',
  [Hostname.Lt]: '6ffbb4d6-2fe9-4fa8-a370-70ce9ac60035',
  [Hostname.Nl]: '4987b2a4-90ae-48b2-b3ed-075cb6593164',
  [Hostname.Pl]: '828f9c88-2f78-4f2c-b3b7-d70b26c99137',
  [Hostname.Pt]: 'ffb5949f-6dfa-4488-9e7d-98839a8ee904',
  [Hostname.Uk]: '304e637f-56e5-40f3-8bd5-70dd486db82e',
  [Hostname.Us]: 'fbd1ccbf-c46c-4860-a81f-1c40283de838',
  [Hostname.Hu]: '8a0bc538-e320-44f2-98d7-08288503d011',
  [Hostname.Sk]: '6ec23816-a6ec-4d89-8120-c72a645dad6c'
};
export const MapHostnameToYieldbirdKey = {
  [Hostname.Fr]: '8d9afc26-9acb-4d12-a757-db592bf7580f',
  [Hostname.Pl]: '6b332917-e417-4b19-b60c-caef1e296484',
  [Hostname.Uk]: '181d93cf-bbde-4771-bbcd-6efc605f5183'
};